import ErrorCheck from './error-check';

export default ErrorCheck;
